import type { ThemeConfig } from 'antd';
import {
  BBA_PRIMARY,
  BBA_PRIMARY_DARK,
  BBA_TERTIARY,
  BBA_ACCENT,
  NEUTRAL_200,
  NEUTRAL_600,
  COLOR_SUCCESS,
  COLOR_WARNING,
  COLOR_DANGER,
  FONT_FAMILY,
} from './tokens';

// Ant Design theme mapped to the BBA / CBS design tokens (same source of truth
// as the MUI theme during the migration). Light blue (#56A1F5) is the dominant
// brand tone; navy (#0D1E6A) for strong text; sky (#00A1DF) for active/links.
const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: BBA_PRIMARY,
    colorInfo: BBA_ACCENT,
    colorLink: BBA_PRIMARY_DARK,
    colorLinkHover: BBA_PRIMARY,
    colorSuccess: COLOR_SUCCESS,
    colorWarning: COLOR_WARNING,
    colorError: COLOR_DANGER,
    colorTextHeading: BBA_TERTIARY,
    colorText: '#27272A',
    colorTextSecondary: NEUTRAL_600,
    colorBorder: NEUTRAL_200,
    colorBorderSecondary: NEUTRAL_200,
    borderRadius: 8,
    fontFamily: FONT_FAMILY,
    fontSize: 14,
    controlHeight: 40,
    colorBgLayout: '#F8FAFC',
  },
  components: {
    Layout: {
      siderBg: '#FFFFFF',
      headerBg: '#FFFFFF',
      bodyBg: '#F8FAFC',
    },
    Menu: {
      itemBg: 'transparent',
      itemColor: NEUTRAL_600,
      itemHoverColor: BBA_TERTIARY,
      itemHoverBg: 'rgba(0,0,0,0.04)',
      itemSelectedColor: BBA_TERTIARY,
      itemSelectedBg: 'rgba(86,161,245,0.14)',
      itemBorderRadius: 10,
      itemMarginInline: 8,
      iconSize: 18,
    },
    Table: {
      headerBg: BBA_PRIMARY,
      headerColor: '#FFFFFF',
      headerSortActiveBg: BBA_PRIMARY_DARK,
      headerSortHoverBg: BBA_PRIMARY_DARK,
      borderColor: NEUTRAL_200,
      rowHoverBg: '#EAF4FE',
      cellPaddingBlock: 14,
    },
    Button: {
      borderRadius: 9999,
      controlHeight: 40,
      fontWeight: 600,
      primaryShadow: 'none',
      defaultShadow: 'none',
    },
    Input: {
      borderRadius: 12,
      controlHeight: 44,
      activeBorderColor: '#A1A1AA',
      hoverBorderColor: '#A1A1AA',
      activeShadow: '0 0 0 2px rgba(161,161,170,0.15)',
    },
    Select: {
      borderRadius: 12,
      controlHeight: 44,
    },
    Card: {
      borderRadiusLG: 16,
      colorBorderSecondary: NEUTRAL_200,
    },
    Tag: {
      borderRadiusSM: 8,
    },
    Modal: {
      borderRadiusLG: 16,
    },
  },
};

export default antdTheme;
